/*
 *
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT-0
 */
import { createContext } from 'react';
import { AdminDemoDefiniton } from '../types';

export const DemoContext = createContext<AdminDemoDefiniton[]>([]);
